import { render, staticRenderFns } from "./PopupInfo.vue?vue&type=template&id=58ee2fde&scoped=true&"
import script from "./PopupInfo.vue?vue&type=script&lang=js&"
export * from "./PopupInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee2fde",
  null
  
)

export default component.exports